import { configureStore } from "@reduxjs/toolkit";
import {
  appReducer,
  setNotifTo,
  setActiveProject,
  setActiveSection,
  toggleSocialLinksLabels,
  activateResumeLink,
} from "./slices/appSlice";

const store = configureStore({
  reducer: {
    app: appReducer,
  },
});

export { store };
export {
  setNotifTo,
  setActiveProject,
  setActiveSection,
  toggleSocialLinksLabels,
  activateResumeLink,
};
